import { format } from "date-fns";
import { CUSTOMER_INCIDENT_ERROR_STATE } from "helpers/sf_constants";
import { generateLast30Days } from "helpers/sf_utils";
import React, { useState } from "react";
import { Card, CardBody, CardHeader, CardTitle, Col, Row, UncontrolledTooltip } from "reactstrap";

const CustomerIncidents = (props) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const last30Days = generateLast30Days();

    const createSlackIncidentsMap = (incidents) => {
        if (!Array.isArray(incidents)) {
            // console.error('Expected incidents to be an array, but got:', incidents);
            return {};
        }
    
        return incidents.reduce((acc, incident) => {
            const date = new Date(incident.reported_at);
            if (!isNaN(date)) {
                const formattedDate = format(date, "yyyy-MM-dd");
                if (!acc[formattedDate]) {
                    acc[formattedDate] = [];
                }
                acc[formattedDate].push(incident);
            } else {
                console.error('Invalid date:', incident.reported_at);
            }
            return acc;
        }, {});
    };

    const slackincidentsMap = createSlackIncidentsMap(props?.customer_incidents);

    const TimeframeRow = () => (
        <Row className="d-flex justify-content-between align-items-center px-1">
            <Col md='auto' className="small">
                30 days ago
            </Col>
            <Col md='10' className="w-75">
                <hr/>
            </Col>
            <Col md='auto' className="small">
                Today
            </Col>
        </Row>
    );

    return (
        <React.Fragment>
            <Row className="d-flex justify-content-center">
                <Col md={10}>
                    <Card>
                        <CardBody>
                            <CardHeader className="d-flex justify-content-between">
                                <CardTitle>Customer Incidents <span><a href='/status-monitor/customer-incidents' className="text-sfblue">(View All)</a></span></CardTitle>
                                <div className="btn btn-outline-primary" onClick={() => props?.triggerCustomerIncidentModalFunc()} type="button">Add New Incident</div>
                            </CardHeader>
                            <div className="status-container p-3">
                                {last30Days.map((day, i) => {
                                    const formattedDate = format(day, "dd");
                                    const incidents = slackincidentsMap[format(day, "yyyy-MM-dd")] || [];
                                    const isIncident = incidents.length > 0;

                                    let statusClass = 'status-bar-success';
                                    if (isIncident) {
                                        if (incidents.some(incident => incident.status === CUSTOMER_INCIDENT_ERROR_STATE.CRITICAL)) {
                                            statusClass = 'status-bar-failure';
                                        } else if (incidents.some(incident => incident.status === CUSTOMER_INCIDENT_ERROR_STATE.ERROR)) {
                                            statusClass = 'status-bar-error';
                                        } else if (incidents.some(incident => incident.status === CUSTOMER_INCIDENT_ERROR_STATE.WARNING)) {
                                            statusClass = 'status-bar-warning';
                                        }
                                    }
                            
                                    return (
                                        <div key={i} className="status-bar-with-date d-flex flex-column align-items-center">
                                            <div
                                                id={`status-bar-${i}`}
                                                className={`status-bar ${statusClass}`}
                                                onMouseEnter={() => isIncident && setHoveredIndex(i)}
                                                onMouseLeave={() => isIncident && setHoveredIndex(null)}
                                            />
                                            <div className="date-label small">{formattedDate}</div>
                                        </div>
                                    );
                                })}

                                {last30Days.map((day, i) => {
                                    const formattedDate = format(day, "yyyy-MM-dd");
                                    const incidents = slackincidentsMap[formattedDate] || [];
                                    return incidents.length > 0 ? (
                                        <UncontrolledTooltip key={i} placement="top" target={`status-bar-${i}`}>
                                            <div className="text-white">
                                                <p className="text-warning">{incidents.length} Incident{incidents.length > 1 ? 's' : ''} Reported</p>
                                                {incidents.map((incident, index) => (
                                                    <div key={index}>
                                                        <p>{incident.title}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </UncontrolledTooltip>
                                    ) : null;
                                })}
                            </div>
                            <TimeframeRow/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default CustomerIncidents